export const initSpecialLinks = (query) => {
    let elements = document.querySelectorAll(query);
    const PHONE_NUM_REGEX = /(?:\+?(61))? ?(?:\((?=.*\)))?(0?[2-57-8]|13)\)? ?(\d\d(?:[- ](?=\d{2,3})|(?!\d\d[- ]?\d[- ]))\d\d[- ]?\d[- ]?\d{2,3})/gi;
    const EMAIL_REGEX = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/gi;

    if (elements.length > 0) {
        elements.forEach((element) => {
            element.innerHTML = element.innerHTML.replace(PHONE_NUM_REGEX, (text) => {
                return '<a href="tel:' + text.replace(/\s+/g, '') + '">' + text + '</a>';
            });

            element.innerHTML = element.innerHTML.replace(EMAIL_REGEX, (text) => {
                return '<a href="mailto:' + text + '">' + text + '</a>';
            });
        });
    }
};